import React from 'react';

interface ArrowIconProps {
    direction?: 'up' | 'down' | 'left' | 'right';
    width?: number;
    height?: number;
    color?: string;
}

const ArrowIcon = ({ direction = 'right', width = 16, height = 16, color = 'white' }: ArrowIconProps) => {
    const rotationMap: Record<string, number> = {
        right: -90,
        down: 0,
        left: 90,
        up: 180,
    };

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            style={{ transform: `rotate(${rotationMap[direction]}deg)` }}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.20031 6.33662C1.93323 6.07517 1.93323 5.64527 2.20031 5.38382L2.39803 5.19027C2.65719 4.93658 3.07159 4.93658 3.33075 5.19027L7.71365 9.48078L12.0966 5.19027C12.3557 4.93658 12.7701 4.93658 13.0293 5.19027L13.227 5.38382C13.4941 5.64527 13.4941 6.07517 13.227 6.33662L8.18001 11.2772C7.92086 11.5309 7.50645 11.5309 7.24729 11.2772L2.20031 6.33662Z"
                fill={color}
                stroke={color}
                strokeWidth="0.2"
            />
        </svg>
    );
};

export default ArrowIcon;
